// frontend/src/types/equipment.ts

export type EquipmentStatus = 'active' | 'retired';
export type EquipmentCondition = 'new' | 'used';

export interface Equipment {
  id: string;
  tank_id: string;
  name: string;
  category: string;
  subcategory?: string;
  brand?: string;
  model?: string;
  serial_number?: string;
  install_date?: string;
  purchase_date?: string;
  purchase_price?: number;
  currency?: string;
  vendor?: string;
  condition?: EquipmentCondition;
  status: EquipmentStatus;
  notes?: string;
  created_at: string;
  updated_at: string;
}

export interface EquipmentCreate {
  name: string;
  category: string;
  subcategory?: string;
  brand?: string;
  model?: string;
  serial_number?: string;
  install_date?: string;
  purchase_date?: string;
  purchase_price?: number;
  currency?: string;
  vendor?: string;
  condition?: EquipmentCondition;
  status?: EquipmentStatus;
  notes?: string;
}

export interface EquipmentUpdate extends Partial<EquipmentCreate> {}

export interface EquipmentListResponse {
  equipment: Equipment[];
  total: number;
}

export interface EquipmentCategoriesResponse {
  categories: Record<string, string[]>;
}

export const CATEGORY_LABELS: Record<string, string> = {
  circulation: 'Circulation',
  skimmer: 'Skimmer',
  filtration: 'Filtration',
  lighting: 'Lighting',
  heating_cooling: 'Heating/Cooling',
  controller: 'Controller',
  automated_testing: 'Automated Testing',
  dosing: 'Dosing',
  ato: 'ATO',
  sterilization: 'Sterilization',
  co2_scrubber: 'CO2 Scrubber',
  other: 'Other',
};

export const SUBCATEGORY_LABELS: Record<string, string> = {
  // Circulation
  return_pump: 'Return Pump',
  wavemaker: 'Wavemaker',
  powerhead: 'Powerhead',
  // Filtration
  filter_roller: 'Filter Roller',
  filter_socks: 'Filter Socks',
  reactor: 'Reactor',
  ats: 'ATS',
  // Lighting
  main_lights: 'Main Lights',
  refugium_light: 'Refugium Light',
  // Heating/Cooling
  heater: 'Heater',
  chiller: 'Chiller',
  fan: 'Fan',
  // Controller
  apex: 'Apex',
  ghl: 'GHL',
  hydros: 'Hydros',
  diy: 'DIY',
  sensors: 'Sensors',
  // Automated Testing
  mastertronic: 'Mastertronic',
  alkatronic: 'Alkatronic',
  aquawiz: 'AquaWiz',
  trident: 'Trident',
  // Dosing
  dosing_pumps: 'Dosing Pumps',
  // Sterilization
  uv_sterilizer: 'UV Sterilizer',
  ozone: 'Ozone',
};
